import { render, staticRenderFns } from "./AddBoardDialog.vue?vue&type=template&id=1e512b4e&"
import script from "./AddBoardDialog.vue?vue&type=script&lang=js&"
export * from "./AddBoardDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports